import axios from '@/utils/request'

export default {
  getUserList: (data) => axios({ url: '/api/store/backUserList', method: 'POST', data }),
  getManagerSelectList: (data) => axios({ url: '/api/store/userInfoSelect', method: 'POST', data }),
  setUserManager: (data) => axios({ url: '/api/store/userManager', method: 'POST', data }), // 设置用户的对接人
  addManager: (data) => axios({ url: '/api/store/adminUserSignUp', method: 'POST', data }),
  editManager: (data) => axios({ url: '/api/store/adminUser', method: 'POST', data }),
  deletManager: (userId) => axios({ url: `/api/store/adminUser/${userId}`, method: 'DELETE' }),

  getUserRole: (userId) => axios({ url: `/api/store/userRole/${userId}` }),

  getAllUserGroup: () => axios({ url: '/api/store/allUserGroup', method: 'GET' }),
  EditUserGroup: (data) => axios({ url: '/api/store/userGroup', method: 'POST', data }),

  getMenuPermissionsList: (params) => axios({ url: '/api/system/menuPermissionsList', method: 'GET', params }), // 获取权限菜单列表
  getMenuPermissionsDetail: (params) => axios({ url: '/api/system/menuPermissionsDetail', method: 'GET', params }), // 获取菜单权限详情
  addOrEditMenuPermissions: (data) => axios({ url: '/api/system/menuPermissions', method: 'PUT', data }), // 新增编辑菜单权限信息
  getSystemRolesList: (params) => axios({ url: '/api/system/systemRolesList', method: 'GET', params }), // 获取角色列表
  addOrEditSystemRoles: (data) => axios({ url: '/api/system/systemRoles', method: 'PUT', data }), // 新增编辑角色信息
  getAllMenuPermissions: (params) => axios({ url: '/api/system/allMenuPermissions', method: 'GET', params }), // 获取全部菜单权限
  getRoleDetail: (params) => axios({ url: '/api/system/roleDetail', method: 'GET', params }), // 获取角色详情
  getRolesMemberList: (data) => axios({ url: '/api/store/user/roles', method: 'POST', data }), // 获取对应角色的用户列表
  deletRoleManager: (id, data) => axios({ url: `/api/store/user/roles?id=${id}`, method: 'DELETE', data }), // 删除角色绑定人员
  getAllSystemUser: (params) => axios({ url: '/api/store/allSystemUser', method: 'GET', params }), // 获取系统所有用户信息
  addRoleMember: (data) => axios({ url: '/api/store/user/roles', method: 'PUT', data }), // 添加角色绑定人员信息
  getRoleResources: (params) => axios({ url: '/api/system/roleResources', method: 'GET', params }), // 获取登录人的角色对应的权限菜单

  // 支付流水
  getPaymentStreamList: (data) => axios({ url: '/api/payment/admin/transactions', method: 'POST', data }), // 获取交易流水
  completedPayment: (paymentId) => axios({ url: `/api/payment/admin/transaction/${paymentId}/completed`, method: 'PUT' }), // 完结流水
  retryPayment: (paymentId) => axios({ url: `/api/payment/admin/transaction/${paymentId}/retry`, method: 'PUT' }), // 完结流水
}
